module.exports = __webpack_public_path__ + "img/gallery1.fb552108.jpg";